import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $;

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {

  @Input() public title:string;
  @Input() public description:string;
  @Input() public callback:string;
  @Input() public size: string;

  @Output() public goToCallback:EventEmitter<string> = new EventEmitter;

  constructor() {
    this.size = this.defaultSize();
  }

  ngOnInit() {
  }

  close(){
    this.emit();
    $('#success-modal').modal('hide');
  }

  emit(){
    if(this.callback)
      this.goToCallback.emit(this.callback);
  }

  open(message){
  
    this.fill(message);
    $('#success-modal').modal('show');
  }

  fill(data){
    this.title = data.title;
    this.description = data.description;
    this.callback = data.callback;

    if (data.size) {
      this.size = data.size
    } else {
      this.size = this.defaultSize();
    }

  }

  defaultSize() {
    return 'sm';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/modals/success-modal/success-modal.component.ts